import { Grid, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SignIn from "../signin-signup/signIn";
import { useSearchParams } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { useContext } from "react";

function Login() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect");
    const { locale } = useContext(LocaleContext);
    const routes = {
        [`/${locale}/user-panel/delete-account`]: t("deleteAccount"),
    };

    return (
        <Grid container item xs={12} justifyContent="center">
            <Grid container item xs={11} md={4} rowGap={1} mt={5}>
                <Grid container item xs={12}>
                    {routes?.[redirect]}
                </Grid>
                <Paper
                    elevation={3}
                    sx={{
                        p: { xs: 2, sm: 3, md: 4 },
                    }}
                >
                    <span>{t("signin")}:</span>
                    <SignIn />
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Login;
